import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeSrcHtml',
})
export class SafeSourceHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

@NgModule({
  declarations: [SafeSourceHtmlPipe],
  exports: [SafeSourceHtmlPipe],
})
export class SafeSourceHtmlModule {}
